var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"war-room-post-topics"},_vm._l((_vm.topics),function(topic){return _c('WarRoomTopic',{key:topic.slug,staticClass:"war-room-post-topics__topic",attrs:{"topic":topic,"size":"small"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }